import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

const AddJobPost = () => {

    const userRole = localStorage.getItem("role");
    const userCity = localStorage.getItem("city");
    const loggedUserID = localStorage.getItem("uid");
    const [categories, setCategories] = useState([]);

    const jobTypes = [
        {
            value: "full-time",
            title: "Fill Time"
        },
        {
            value: "part-time",
            title: "Part Time"
        }
    ]

    const initialFormData = {
        category: "",
        jobTitle: "",
        location: "",
        salary: "",
        jobType: "",
        jobDescription: ""
    }
    const [formData, setFormData] = useState(initialFormData);
    const navigate = useNavigate();

    const handleChange = (e) => {
        e.preventDefault()

        let name = e.target.name
        let value = e.target.value

        // if (name === "phoneNo" || name === "salary") { value = parseInt(value) }

        setFormData({ ...formData, [name]: value })
    }

    // Fetch categories
    const fetchCategories = async () => {
        try {
            const res = await HomeService.getJobCategory();
            console.log("UY57", res.data);

            if (res?.data) {
                setCategories(res.data);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.category) return toast.error("Category should not be empty")
        if (!formData.jobTitle) return toast.error("Title should not be empty")
        console.log("KJH76", formData);
        // return
        try {
            const res = await HomeService.addJobPost(formData);
            if (res?.status) {
                toast.success("Job posted successfully!");

                navigate("/manage-job-post");
            }
        } catch (error) {
            toast.error("Failed to add Locality.");
            console.error("Error adding Locality:", error);
        }
    };

    useEffect(() => {
        fetchCategories()
    }, [])




    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid">
                <div className="mt-5">
                    <div style={headLineStyle} className="page-headline">
                        Add Job Vacancy
                    </div>
                    <hr />

                    <section className="chartBox_area">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <label>
                                        Category<span className="text-danger">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="category"
                                        value={formData?.category || ""}
                                        onChange={(e) => handleChange(e)}
                                        required
                                    >
                                        <option value="" disabled>---Select---</option>
                                        {categories
                                        .filter(item=>item.status)
                                        .map((item) => (
                                            <option key={item._id} value={item._id}>
                                                {item.catName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-6 mt-3">
                                    <label htmlFor="designation">
                                        Job Type<span className="text-danger">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="jobType"
                                        value={formData?.jobType || ""}
                                        onChange={(e) => handleChange(e)}
                                    >
                                        <option value="">---Select---</option>
                                        {jobTypes.map((item, key) => (
                                            <option key={key} value={item.value}>
                                                {item.title}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-12 mt-3">
                                    <label htmlFor="name">
                                        Job Title<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="jobTitle"
                                        value={formData?.jobTitle || ""}
                                        onChange={(e) => handleChange(e)}
                                        placeholder="Enter Job Title"
                                        required
                                    />
                                </div>

                                <div className="col-md-8 mt-3">
                                    <label htmlFor="name">
                                        Location
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="location"
                                        value={formData?.location || ""}
                                        onChange={(e) => handleChange(e)}
                                        placeholder="Enter job location"
                                    />
                                </div>
                                <div className="col-md-4 mt-3">
                                    <label htmlFor="name">
                                        Salary
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="salary"
                                        value={formData?.salary || ""}
                                        onChange={(e) => handleChange(e)}
                                        placeholder="Enter offered salary"
                                    />
                                </div>

                                <div className="col-md-12 mt-3">
                                    <label>
                                        Description
                                    </label>

                                    <textarea
                                        className="form-control"
                                        name="jobDescription"
                                        value={formData?.jobDescription || ""}
                                        onChange={(e) => handleChange(e)}
                                        placeholder="Enter description"
                                    ></textarea>
                                </div>

                            </div>
                            <button type="submit" className="btn mt-3" style={{
                                background: 'rgb(133, 218, 79)',
                                borderRadius: '13px'
                            }}>
                                Add
                            </button>
                        </form>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default AddJobPost
